import { render } from "./InstructorLedDetailsView.vue?vue&type=template&id=3c77a07c"
const script = {}

import exportComponent from "/codebuild/output/src900218826/src/production-ready-serverless-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__